import { stdObject } from "../data/types/stdObject";

export const getChildrenValues = (
  codPadre: string | number,
  categories: Array<stdObject>
) => {
  let children = categories.filter(
    (e: stdObject) => e.PADCAT === codPadre.toString()
  );
  let resultado: Array<Number> = [];

  for (let child of children) {
    resultado.push(child["CODCAT" as keyof typeof child]);
    resultado = resultado.concat(
      getChildrenValues(child["CODCAT" as keyof typeof child], categories)
    );
  }
  return resultado;
};
